/**
 * @Description 选址地图青春版埋点
 */

import { getRadiusByRangeType } from '../components/business/YouthMap/AreaDetailDrawer/components/FirstScreenRight/ts-config';

export const trackingYouthZoomChange: any[] = Object.values({
  event_id: '9acc766e-743c-425c-85f8-fe37edc538b8',
  op_feat: '地图中-放大/缩小一次',
  desc: '地图中-放大/缩小一次',
  opObj: {
    op_event: '',
    op_block: '地图拖动/缩放',
  },
});

export const trackingYouthMoveChange: any[] = Object.values({
  event_id: '158ddab5-7958-495e-b254-3b8594e46b3a',
  op_feat: '地图中-拖动一次',
  desc: '地图中-拖动一次',
  opObj: {
    op_event: '',
    op_block: '地图拖动/缩放',
  },
});

export const trackingYouthCityChange: any[] = Object.values({
  event_id: '1483c5f4-8bd6-41cc-adde-770ca9511792',
  op_feat: '切换城市',
  desc: '点击了切换城市',
  opObj: {
    op_event: '',
    op_block: '城市切换',
  },
});

export const trackingYouthSearch: any[] = Object.values({
  event_id: '6f283469-3fe7-4634-b08f-64e586ea42c7',
  op_feat: '搜索',
  desc: '点击了搜索',
  opObj: {
    op_event: '',
    op_block: '搜索',
  },
});

export const trackingYouthViewChange: any[] = Object.values({
  event_id: '5326cf85-76bd-4be0-9fc8-5e2e829c0484',
  op_feat: '门店/省份/城市切换',
  desc: '点击了门店/省份/城市切换',
  opObj: {
    op_event: '',
    op_block: '门店/省份/城市切换',
  },
});

export const trackingYouthProvinceLayer: any[] = Object.values({
  event_id: '71e753aa-fdee-4e9d-af4d-8aadc043479e',
  op_feat: '地图中-省份聚合圈',
  desc: '点击了地图中-省份聚合圈',
  opObj: {
    op_event: '',
    op_block: '省份聚合圈',
  },
});

export const trackingYouthCityLayer: any[] = Object.values({
  event_id: 'a99c9fde-6013-43a5-8cc5-e743fb708236',
  op_feat: '地图中-城市聚合圈',
  desc: '点击了地图中-城市聚合圈',
  opObj: {
    op_event: '',
    op_block: '城市聚合圈',
  },
});


export const trackingYouthViewOwnBrand: any[] = Object.values({
  event_id: '0c066d28-c79a-4e30-b28a-2fbd9edca6a1',
  op_feat: '地图中-品牌门店图标',
  desc: '移入了地图中-品牌门店图标',
  opObj: {
    op_event: '',
    op_block: '查看品牌门店',
  },
});

// export const trackingYouthViewArea: any[] = Object.values({
//   event_id: 'b3199324-a180-407d-9e57-3c12ae2df30c',
//   op_feat: '地图中-开店区域围栏',
//   desc: '点击了地图中-开店区域围栏',
//   opObj: {
//     op_event: '',
//     op_block: '点击开店区域围栏',
//   },
// });

// export const trackingYouthViewListArea: any[] = Object.values({
//   event_id: 'cbdbdab3-1386-47de-a1a0-cbb33d6458ed',
//   op_feat: '列表-开店区域名称展开',
//   desc: '点击了列表-开店区域名称展开',
//   opObj: {
//     op_event: '',
//     op_block: '开店区域列表展开',
//   },
// });

// export const trackingYouthListViewDetail: any[] = Object.values({
//   event_id: '9df2fd13-cd6b-44f1-8fb4-2f59e12bbcb2',
//   op_feat: '列表-查看开店区域详情按钮',
//   desc: '点击了列表-查看开店区域详情按钮',
//   opObj: {
//     op_event: '',
//     op_block: '开店区域列表查看详情',
//   },
// });

// export const trackingYouthFilterLayer: any[] = Object.values({
//   event_id: '0aa41f98-9ed1-47e4-9dfa-f1f487b72331',
//   op_feat: '筛选-图层设置',
//   desc: '点击了筛选-图层设置',
//   opObj: {
//     op_event: '',
//     op_block: '筛选-图层设置',
//   },
// });

export const trackingYouthDetailZoomChange: any[] = Object.values({
  event_id: 'f450aa9a-f942-4a69-b4a6-3960aadb7e81',
  op_feat: '详情-地图中-放大/缩小一次',
  desc: '地图中-放大/缩小一次',
  opObj: {
    op_event: '',
    op_block: '详情-地图拖动/缩放',
  },
});

export const trackingYouthDetailMoveChange: any[] = Object.values({
  event_id: '7efd7cd9-cc5c-4fda-a62c-8c63e13998af',
  op_feat: '详情-地图中-拖动一次',
  desc: '地图中-拖动一次',
  opObj: {
    op_event: '',
    op_block: '详情-地图拖动/缩放',
  },
});

export const trackingYouthDetailShopTab = (op_event) => {
  return Object.values({
    event_id: 'd1b79ca9-023a-40b9-b9f1-a63bd5c99cb6',
    op_feat: '经营门店TAB切换',
    desc: '点击了经营门店TAB切换',
    opObj: {
      op_event: op_event,
      op_block: '详情-经营门店TAB切换',
    },
  });
};

export const trackingYouthDetailSurroundTab: any[] = Object.values({
  event_id: 'a6dd7374-343c-4eaa-bc79-f4de90bdda06',
  op_feat: '周边配套TAB切换',
  desc: '点击了周边配套TAB切换',
  opObj: {
    op_event: '',
    op_block: '详情-周边配套TAB切换',
  },
});

/**
 * 获取人口热力图事件数据
 * @param keyName 格式为：人口类型_距离范围code，如 livePopulations_5 代表居住人口500m
 * @returns 事件ID
 */
export const getPopulationTrackingData = (keyName: string) => {

  const [nameKey, code] = keyName.split('_');
  const nameKeyMap = {
    livePopulations: '居住人口',
    workPopulations: '工作人口',
    residentPopulations: '常住人口',
  };
  const name = nameKeyMap[nameKey] || '';
  const distance = getRadiusByRangeType(code) || 0;
  const eventIdMap = {
    livePopulations_5: '86c16c29-13ac-4ec4-8d25-7cdfb9cc9e47',
    livePopulations_15: '241494fd-c26a-44e3-9367-1dc275c56627',
    livePopulations_30: '8092483f-f712-44fc-88ba-fce52cee4bb2',
    workPopulations_5: '8fcbe4da-c745-45b4-aea8-099d5e05930c',
    workPopulations_15: '8f63a469-5cd6-4f69-9bd2-ce440aec7f5c',
    workPopulations_30: '16d55012-4337-4750-b679-b876fb948ef8',
    residentPopulations_5: '3595a039-7be2-4958-93e0-f2adec44c884',
    residentPopulations_15: 'd9b77e08-39d7-4fb4-8864-de84b656e40c',
    residentPopulations_30: '138aac95-692b-4775-8cab-56890329bfe8',
  };

  return {
    event_id: eventIdMap[keyName],
    op_feat: '热力图',
    desc: `点击【${name}热力】${distance}`,
    opObj: {
      op_event: '点击了热力图',
      op_block: `详情-开启【${name}】${distance}m热力图`,
    }
  };
};



// 本品牌筛选开关
export const trackingYouthFilterSelfBrand: any[] = Object.values({
  event_id: 'ffa9384b-e65a-4923-9180-f939e3a2f4ac',
  op_feat: '本品牌开关',
  desc: '点击本品牌开关',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});
// 本品牌筛选点击完成
export const trackingYouthFilterSelfBrandAll: any[] = Object.values({
  event_id: 'e3ef0ba7-dd53-4348-8755-76fe42e6fa93',
  op_feat: '本品牌筛选',
  desc: '点击了本品牌筛选',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});
// 竞品品牌筛选开关
export const trackingYouthFilterOtherBrand: any[] = Object.values({
  event_id: 'c1c17459-2019-4d4f-b68a-bace3233dd92',
  op_feat: '竞品开关',
  desc: '点击了竞品开关',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});
// 竞品品牌筛选点击完成
export const trackingYouthFilterOtherBrandAll: any[] = Object.values({
  event_id: '57e5f414-72bc-4e4d-8229-0d83638e6ce9',
  op_feat: '竞品筛选',
  desc: '点击了竞品',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});

// 商圈筛选开关
export const trackingYouthFilterBusinessCircle: any[] = Object.values({
  event_id: 'd6bd9c35-99a1-41bb-8636-5a86a9b1c9f4',
  op_feat: '商圈开关',
  desc: '点击了商圈开关',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});
// 商圈筛选点击完成
export const trackingYouthFilterBusinessCircleAll: any[] = Object.values({
  event_id: 'dd1e03d6-2549-45a7-8a7b-6e277ce579f5',
  op_feat: '商圈筛选',
  desc: '商圈筛选',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});

// 图层显示筛选点击完成
export const trackingYouthFilterLayerFilter: any[] = Object.values({
  event_id: '4e0ec61a-dc91-46ad-be5e-b46f22a83087',
  op_feat: '图层显示',
  desc: '点击图层显示',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});

// 行政区域筛选
export const trackingYouthFilterDistrict: any[] = Object.values({
  event_id: '478d8cf2-d7a9-4aa5-9694-f430b7748ef7',
  op_feat: '行政区筛选',
  desc: '点击行政区筛选',
  opObj: {
    op_event: '',
    op_block: '选址地图青春版',
  },
});

// 点击周边配套的小区
export const trackingYouthCommunityList: any[] = Object.values({
  event_id: '812dc801-2263-4cfa-9d4f-820a76b620d1',
  op_feat: '详情页-小区列表',
  desc: '点击了详情页-小区列表',
});
